
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'FbxInputIcon',
    props: {
        value: {
            type: String,
            default: '',
        },
    },
    emits: ['onIconClick'],
    methods: {
        onIconClick() {
            this.$emit('onIconClick', '');
        },
    },
});
